import { useSignInContext } from "./SignInContext"
import { StepKey } from "./StepKey"
import { StepKeyID } from "./StepKeyID"
import { StepOTPCode } from "./StepOTPCode"
import { StepOTPSend } from "./StepOTPSend"
import { StepSessionTimeout } from "./StepSessionTimeout"
import { useKeySignIn } from "./useKeySignIn"
import { useEmailSignIn, useTextMessageSignIn } from "./useOTPSignIn"

export function Step() {
  const { step } = useSignInContext()

  const {
    signInWithKey,
    signInWithKeyID,
    errorMessage: keyAuthErrorMessage,
    isSigningInWithKeyID,
  } = useKeySignIn()

  const {
    sendTextMessage,
    isSendingTextMessage,
    sendTextMessageError,
    authenticateTextMessage,
    isAuthenticatingTextMessage,
    authenticateTextMessageError,
    maskedPhoneNumber,
    resendTextMessage,
  } = useTextMessageSignIn()

  const {
    sendEmail,
    isSendingEmail,
    sendEmailError,
    authenticateEmail,
    isAuthenticatingEmail,
    authenticateEmailError,
    maskedEmailAddress,
    resendEmail,
  } = useEmailSignIn()

  switch (step) {
    case "key":
      return <StepKey onClickScanKey={signInWithKey} />
    case "key-id":
      return (
        <StepKeyID
          onSubmit={signInWithKeyID}
          isSubmitting={isSigningInWithKeyID}
          errorMessage={keyAuthErrorMessage}
        />
      )
    case "text-message":
      return (
        <StepOTPSend
          title="Sign in using text message"
          onSubmit={sendTextMessage}
          isSubmitting={isSendingTextMessage}
          errorMessage={sendTextMessageError}
        />
      )
    case "text-message-code":
      return (
        <StepOTPCode
          title="Sign in using text message"
          sentTo={maskedPhoneNumber}
          onSubmit={authenticateTextMessage}
          isSubmitting={isAuthenticatingTextMessage}
          onClickSendAnotherCode={resendTextMessage}
          isSendingAnotherCode={isSendingTextMessage}
          errorMessage={authenticateTextMessageError}
        />
      )
    case "email":
      return (
        <StepOTPSend
          title="Sign in using email"
          onSubmit={sendEmail}
          isSubmitting={isSendingEmail}
          errorMessage={sendEmailError}
        />
      )
    case "email-code":
      return (
        <StepOTPCode
          title="Sign in using email"
          sentTo={maskedEmailAddress}
          onSubmit={authenticateEmail}
          isSubmitting={isAuthenticatingEmail}
          onClickSendAnotherCode={resendEmail}
          isSendingAnotherCode={isSendingEmail}
          errorMessage={authenticateEmailError}
        />
      )
    case "session-timeout":
      return (
        <StepSessionTimeout
          onClickScanKey={signInWithKeyID}
          onClickSendEmail={sendEmail}
          onClickSendTextMessage={sendTextMessage}
          isSubmitting={isSendingTextMessage}
          errorMessage={keyAuthErrorMessage || sendTextMessageError}
        />
      )
    default:
      return null
  }
}
